import React, { useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiLineItems } from "~/routes"

import PageContainer from "~/library/PageContainer"
import LineItemForm from "~/components/LineItemForm"
import LoadingWrapper from "~/library/LoadingWrapper"
import LineItem from "~/types/LineItem"

const EditLineItem = () => {
  const [isLineItemUpdated, setIsLineItemUpdated] = useState<boolean>(false)

  const { id } = useParams<{ id: string }>()
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const endpoint = apiLineItems.show.path({ venueSlug, id: id! })
  const { data: lineItem, isLoading } = useFetchResource<{ lineItem: LineItem }, "lineItem">(
    endpoint,
    "lineItem",
    {}
  )

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      id: id!,
      line_item: formValues,
    }

    const req = apiLineItems.update({ data })
    req
      .then(() => {
        setIsLineItemUpdated(true)
        toast("Line item updated successfully", "success")
      })
      .catch((res) => {
        toast(res.body?.errors?.join(", ") || "Please try again", "danger")
      })
  }

  if (isLineItemUpdated) {
    return <Navigate to={`/line-items/${id}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Line Item</h3>
          <LoadingWrapper isLoading={isLoading}>
            <LineItemForm
              venueSlug={venueSlug}
              onSubmit={handleSubmit}
              initialValues={lineItem}
              isEditing={true}
            />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default EditLineItem
